import styled from 'styled-components'
import { Well } from '@zendeskgarden/react-notifications'

export const WrapperWell = styled(Well)`
  margin-top: 1em;
`
